import { render, staticRenderFns } from "./Comprados.html?vue&type=template&id=07feb72f&scoped=true&"
import script from "./Comprados.vue?vue&type=script&lang=js&"
export * from "./Comprados.vue?vue&type=script&lang=js&"
import style0 from "./Comprados.scss?vue&type=style&index=0&id=07feb72f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07feb72f",
  null
  
)

export default component.exports